<template>
    <div style="width: 100vw;">
        <b-img :src="require('../assets/10.jpg')" fluid alt="Responsive image" />
        <h2 class="mt-4 text-center d-block" style="width: 100%">Share Your Set</h2>
        <b-row style="text-align: center">
            <b-col>
                <social-sharing url="https://www.stickiton.org.uk" :title="'Check out my Stick It On set: ' + trackList" :description="trackList"
                                :quote="'Check out my Stick It On set: ' + trackList" hashtags="stickiton,choons,djdemocracy" inline-template>
                    <div>
                        <network network="facebook" style="color: rgba(235, 63, 36,100)">
                            <font-awesome-icon :icon="['fab','facebook']" size="5x"></font-awesome-icon>
                        </network>
                        <network network="twitter" style="margin-left: 20px; color: rgba(235, 63, 36,100)">
                            <font-awesome-icon :icon="['fab','twitter']" size="5x"></font-awesome-icon>
                        </network>
                    </div>
                </social-sharing>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import SocialSharing from 'vue-social-sharing';
    import { EventBus } from "../EventBus";
    import _ from 'lodash';
    export default {
        name: "ShareSet",
        components: {SocialSharing},
        data() {
            return {
                trackList: '',
                tempTracks: []
            }
        },
        mounted() {
            EventBus.$emit('loading-show');
            this.$axios.get(`booking/email/${this.$store.state.user.email}`).then(result => {
                EventBus.$emit('loading-hide');
                const resTracks = result.data.tracks;
                _.forEach(resTracks, (track) => {
                    this.tempTracks.push(processTrackToOneLine(track));
                });
                let uls = '';
                _.forEach(this.tempTracks, (track) => {
                    uls = uls + `${track}, `;
                });
                this.trackList = uls;
            }).catch(err => {
                EventBus.$emit('loading-hide');
                EventBus.$emit('message', {message: err.message, type: 'danger'});
            });
        }
    }

    function processTrackToOneLine(obj) {
        return `${obj.artist} - ${obj.track}`;
    }
</script>

<style scoped>

</style>
